import {Component} from '@angular/core';

@Component({
    selector: 'app-employment',
    templateUrl: './employment.component.html',
    styleUrls: ['./employment.component.css'],
    standalone: false
})
export class EmploymentComponent {

    constructor() {
    }

}
